var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.90925L13.6923 4.69141L12.6714 1H3.84615C2.82654 1 2 1.70829 2 2.58203V17.418C2 18.2917 2.82654 19 3.84615 19H16.1538C17.1735 19 18 18.2917 18 17.418V5.90925Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 5.90909H13.8512C13.1993 5.90909 12.666 5.41818 12.666 4.81818V1C12.8201 1 12.9742 1.05455 13.0808 1.16367L17.8215 5.52731C17.9401 5.62545 17.9993 5.76727 17.9993 5.90909Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11133 9.1818C5.11133 8.95586 5.31031 8.77271 5.55577 8.77271H14.4447C14.6901 8.77271 14.8891 8.95586 14.8891 9.1818C14.8891 9.40773 14.6901 9.59089 14.4447 9.59089H5.55577C5.31031 9.59089 5.11133 9.40773 5.11133 9.1818Z",
    fill: "#EEF6FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11133 11.6363C5.11133 11.4104 5.31031 11.2273 5.55577 11.2273H14.4447C14.6901 11.2273 14.8891 11.4104 14.8891 11.6363C14.8891 11.8623 14.6901 12.0454 14.4447 12.0454H5.55577C5.31031 12.0454 5.11133 11.8623 5.11133 11.6363Z",
    fill: "#EEF6FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11133 14.0909C5.11133 13.865 5.31031 13.6818 5.55577 13.6818H9.55577C9.80123 13.6818 10.0002 13.865 10.0002 14.0909C10.0002 14.3168 9.80123 14.5 9.55577 14.5H5.55577C5.31031 14.5 5.11133 14.3168 5.11133 14.0909Z",
    fill: "#EEF6FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquity);
export default __webpack_public_path__ + "static/media/equity.212066a6.svg";
export { ForwardRef as ReactComponent };